// Pixel-density guidance profiles. Geometry/angle limits remain explicit design
// assumptions; selecting a profile does not certify an installation.
export const IEC_SOURCE = 'https://whitepapers.axis.com/download/wp_pixel_density_based_on_iec_62676_4_2025_t10228570_2512.pdf';
export const LEGACY = [
  { k: 'detect', label: 'Detect', px: 25 }, { k: 'observe', label: 'Observe', px: 62.5 },
  { k: 'recognise', label: 'Recognise', px: 125 }, { k: 'identify', label: 'Identify', px: 250, face: true }
];
export const IEC2025 = [
  { k: 'overview', label: 'Overview', px: 20 }, { k: 'outline', label: 'Outline', px: 40 },
  { k: 'discern', label: 'Discern', px: 80 }, { k: 'perceive', label: 'Perceive', px: 125 },
  { k: 'characterize', label: 'Characterize', px: 250 },
  { k: 'validate', label: 'Validate', px: 500, face: true },
  { k: 'scrutinize', label: 'Scrutinize', px: 1500, face: true }
];
export const PROFILES = [
  { id: 'dori-2015', name: 'Legacy DORI · EN 62676-4:2015', levels: LEGACY },
  { id: 'iec-2025', name: 'IEC 62676-4:2025 · density guidance', levels: IEC2025, source: IEC_SOURCE },
  { id: 'custom', name: 'Custom project thresholds', levels: LEGACY }
];
export function profile(S) { return PROFILES.find(p => p.id === S.opt.profile) || PROFILES[0]; }
export const generalKey = S => S.opt.generalReq || LEGACY[Math.max(0, Math.min(3, Math.round(S.opt.general) - 1))].k;
export function threshold(S, key) {
  return S.opt.t?.[key] ?? [...LEGACY, ...IEC2025].find(p => p.k === key)?.px ?? (key === 'plate' ? 200 : 125);
}
export const needsFace = key => key === 'identify' || key === 'validate' || key === 'scrutinize';
export const detailLevels = S => [{ k: 'none', label: 'Blind', px: 0 }, ...profile(S).levels.map(p => ({ ...p, px: threshold(S, p.k) }))];
export function profileSnapshot(S) { return { id: profile(S).id, name: S.opt.profileName || profile(S).name, source: profile(S).source || '', thresholds: { ...S.opt.t } }; }
export function chooseProfile(S, id) {
  const p = PROFILES.find(p => p.id === id) || PROFILES[0];
  S.opt.profile = p.id; S.opt.profileName = p.name;
  if (id !== 'custom') for (const level of p.levels) S.opt.t[level.k] = level.px;
  // Preserve old zone/task requirements; changing the profile does not rewrite
  // their meaning. New general coverage is an explicit choice in the editor.
  if (!S.opt.generalReq) S.opt.generalReq = generalKey(S);
}
